


















































































































































import { mapActions, mapGetters }     from 'vuex'
import { Vue, Component, Prop, Watch }          from 'vue-property-decorator'
import { formatDate, isObject }                             from '@/utils/helpers'
import { Ability }                              from '@/types/Ability'
import _                                        from 'lodash'
import { Etat, getEtatSpecReclamation, TypeReclamation, TypeReponseReclamation }             from '@/types/Reclamation'
import  ErrorDisplay                            from '@/components/ErrorDisplay.vue'
import { CandidatStatut } from '@/types/Candidat'

@Component({
    components: {
        ErrorDisplay
    },
    computed: {
        ...mapGetters('reclamation', ['loading', 'reclamationSelect', 'error']),
        ...mapGetters('reclamationType', ['reclamationTypes']),
        ...mapGetters('auth', ['authUser', 'can', 'cannot', 'isA', 'isNotA'])
    },
    methods: {
        ...mapActions('postes', ['getAllPostes'])
    }
})

export default class PopupEditReclamation extends Vue {
    @Prop() show?: boolean;
    @Prop() infosFiliereEpreuveSelect?: any;
    @Prop() type_reclamation?: string

    Ability                              = Ability
    CandidatStatut = CandidatStatut
    reclamationSelectLocal: any          = {}
    etat_reclamation_select: any         = {}
    etat_avancement = Etat.ETAT_NON_TRAITE
    reclamation_type_id = null
    activerRectifiationNote              = false
    lockInput                            = false
    Etat                                 = Etat
    erreur_manqueNote: any               = null


    reclamationTypesTemps: Array<any> = []

    @Watch('activerRectifiationNote')
    @Watch('etat_avancement')
    etatAvancementChangeHandler() {
        this.reclamationTypesTemps = this.$store.state.reclamationType.reclamationTypes
        if (this.etat_avancement === Etat.ETAT_REJETEE) {
            this.reclamationTypesTemps  = this.reclamationTypesTemps.filter((r: any) => r.type_reponse === TypeReponseReclamation.TYPE_REPONSE_REJETEE)
        } else if (this.etat_avancement === Etat.ETAT_TRAITE) {
            if (this.activerRectifiationNote) {
                this.reclamationTypesTemps  = this.reclamationTypesTemps.filter((r: any) => r.type_reponse === TypeReponseReclamation.TYPE_REPONSE_ACCEPTEE)
            } else {
                this.reclamationTypesTemps  = this.reclamationTypesTemps.filter((r: any) => r.type_reponse === TypeReponseReclamation.TYPE_REPONSE_REFUSEE)
            }
        }
        if (this.reclamationTypesTemps.length === 1) {
            this.reclamation_type_id = this.reclamationTypesTemps[0].id
        }
    }


    @Watch('reclamationSelect')
    majInterface () {
        if (this.$store.state.reclamation.reclamationSelect) {
            // on fait un clone car ici, on part directement de reclamationSelect, on ne refait pas de get, donc il faut éviter d'impacter directement le store lorsqu'on va modifier les données sur l'interface.
            this.reclamationSelectLocal = _.cloneDeep(this.$store.state.reclamation.reclamationSelect)
            this.initInterface()
        } else {
            this.reclamationSelectLocal = {}
            this.lockInput = false
            this.getEtatAvancementReclamation()
        }
    }

    initInterface () {
        this.$store.dispatch('reclamationType/getReclamationTypes',  { 'filter-type_reclamation': TypeReclamation.TYPE_NOTE_ECRIT }).then(() => {
            this.lockInput = !!this.reclamationSelectLocal.validated_at;
            this.activerRectifiationNote = !!this.reclamationSelectLocal.note;
            this.getEtatAvancementReclamation()
        })
    }

    isObjectLocal (value: any) {
        return isObject(value)
    }

    /** force la saisie à 2 décimales (troncature, pas d'arrondi) */
    updateNote() {
        if (this.reclamationSelectLocal.note) {
            const noteReplaced = this.reclamationSelectLocal.note.toString().replace(',', '.')
            if (noteReplaced) {
                const partieEntiere = noteReplaced.split('.')[0]
                const partieDecimale = noteReplaced.split('.')[1]
                const NoteReformatee = (partieEntiere ? partieEntiere.toString() : '0') + (partieDecimale ? '.' + partieDecimale.slice(0, 2) : '')
                this.$nextTick(function () {
                    this.reclamationSelectLocal.note = NoteReformatee
                })
            }
        }
    }

    finaliseNote() {
        if (this.reclamationSelectLocal.note) {
            // permet de reformater en .00 si on n'a pas de décimale. Pas de risque d'arrondi puisqu'on a déjà forcé à 2 décimales via l'event updateNote
            this.reclamationSelectLocal.note = parseFloat(this.reclamationSelectLocal.note).toFixed(2)
        } else {
            this.reclamationSelectLocal.note = ''
        }
    }

    /** récupère la couleur d'état d'avancement du traitement de la réclamation  */
    getEtatAvancementReclamation() {
        let etat = Etat.ETAT_NON_TRAITE
        switch(true) {

            case this.reclamationSelectLocal.rejected_at !== null:
                etat = Etat.ETAT_REJETEE
                this.etat_avancement = Etat.ETAT_REJETEE
                break
            case (this.reclamationSelectLocal.submitted_at === null &&  this.reclamationSelectLocal.validated_at === null) && (this.reclamationSelectLocal.note !== null || this.reclamationSelectLocal.message_gestionnaire !== null):
                etat = Etat.ETAT_EN_COURS
                this.etat_avancement = Etat.ETAT_NON_TRAITE
                break
            case this.reclamationSelectLocal.submitted_at !== null &&  this.reclamationSelectLocal.validated_at === null:
                etat = Etat.ETAT_TRAITE
                this.etat_avancement = Etat.ETAT_TRAITE
                break
            case this.reclamationSelectLocal.submitted_at !== null &&  this.reclamationSelectLocal.validated_at !== null:
                etat = Etat.ETAT_SIGNE
                this.etat_avancement = Etat.ETAT_SIGNE
                break
            case this.reclamationSelectLocal.submitted_at === null &&  this.reclamationSelectLocal.validated_at === null :
                etat = Etat.ETAT_EN_COURS
                this.etat_avancement = Etat.ETAT_NON_TRAITE
                break
        }

        /*
        if (!this.reclamationSelectLocal.submitted_at && !this.reclamationSelectLocal.validated_at) {
            etat = Etat.ETAT_NON_TRAITE
            this.etat_avancement = Etat.ETAT_NON_TRAITE
        }
        if ((!this.reclamationSelectLocal.submitted_at && !this.reclamationSelectLocal.validated_at && !this.reclamationSelectLocal.message_gestionnaire) ||
        (!this.reclamationSelectLocal.submitted_at && !this.reclamationSelectLocal.validated_at && !this.reclamationSelectLocal.note)) {
            etat = Etat.ETAT_EN_COURS
            this.etat_avancement = Etat.ETAT_EN_COURS
        }
        if (this.reclamationSelectLocal.submitted_at && !this.reclamationSelectLocal.validated_at) {
            etat = Etat.ETAT_TRAITE
            this.etat_avancement = Etat.ETAT_TRAITE
        }
        if (this.reclamationSelectLocal.submitted_at && this.reclamationSelectLocal.validated_at) {
            etat = Etat.ETAT_SIGNE
            this.etat_avancement = Etat.ETAT_SIGNE
        }
        if (this.reclamationSelectLocal.rejected_at) {
            etat = Etat.ETAT_REJETEE
            this.etat_avancement = Etat.ETAT_REJETEE
        }
        */
        this.etat_reclamation_select = getEtatSpecReclamation(etat)
        this.reclamation_type_id = this.reclamationSelectLocal && this.reclamationSelectLocal.reclamationType ? this.reclamationSelectLocal.reclamationType.id : null
    }

    /** Retourne la liste passée en paramètre ordonnée par name */
    orderedListe (liste: any) {
        return _.orderBy(liste, 'name', 'asc')
    }

    // active/désactive la rectification de la note du candidat
    activationRectificationNote () {
        this.activerRectifiationNote = !this.activerRectifiationNote
    }

    /**
     * Ferme la popup avec réinit des variables locales sensibles.
     */
    closeModal () {
        this.erreur_manqueNote = null
        this.reclamationSelectLocal = {}
        this.$emit('reinitShow', null)
    }

    /** gère un contrôle de la validité de la saisie de la réclamation avant de l'enregistrer */
    controlesaveReclamation () {
        this.erreur_manqueNote = null

        if (this.activerRectifiationNote && !this.reclamationSelectLocal.note) {
            this.erreur_manqueNote = 'Vous devez renseigner une note rectifiée valable.'
        } else {
            // on lance l'enregistrement de la réclamation si pas d'erreur sur sa validité
            this.saveReclamation()
        }
    }

    /**
     * Enregistrement de la réclamation
     */
    saveReclamation () {
        const idInfo = 't_info_' + Math.random()
        const infosToaster = {
            id: idInfo,
            toaster: 'b-toaster-top-right',
            variant: 'primary',
            noCloseButton: true,
            fade: true,
            noAutoHide: true
        }

        const params = {
            reclamation_id: this.reclamationSelectLocal.id,
            type: this.$props.type_reclamation,
            payload: {
                message_gestionnaire: this.reclamationSelectLocal.message_gestionnaire,
                note: this.reclamationSelectLocal.note,
                decision: this.activerRectifiationNote,
                reclamation_type_id: this.reclamation_type_id,
                submit: this.etat_avancement
            }
        }

        this.$bvToast.toast('Enregistrement en cours...', infosToaster)
        this.$store.dispatch('reclamation/updateReclamation', params)
            .then(() => {
                const idSucces = 't_succes_' + Math.random()
                const succesToaster = {
                    id: idSucces,
                    toaster: 'b-toaster-top-right',
                    variant: 'success',
                    noCloseButton: true,
                    fade: true,
                    autoHideDelay: 5000
                }
                this.$bvToast.toast('Enregistrement terminé', succesToaster)
                this.closeModal()
            })
            .finally(() => {
                this.$bvToast.hide(idInfo)
            })
    }

    /**
     * Aperçu de la correction de la copie du candidat
     */
    showCorrection (item: any) {
        if (item && item.id !== undefined) {
            window.open(this.$store.getters['candidat/getCorrectionOnViatique'](item.id), '_blank')
        }
    }

    /** Formattage de date */
    formatteDate (date: Date) {
        return formatDate(date)
    }
}

